"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const path = require('path');
class TwingFileExtensionEscapingStrategy {
    /**
     * Guesses the best autoescaping strategy based on the file name.
     *
     * @param {string} name The template name
     *
     * @return string | Function | false The escaping strategy to use or false to disable
     */
    static guess(name) {
        let extension = path.extname(name);
        if (extension === '.twig') {
            name = path.basename(name, extension);
            extension = path.extname(name);
        }
        switch (extension) {
            case '.js':
                return 'js';
            case '.css':
                return 'css';
            case '.txt':
                return false;
            default:
                return 'html';
        }
    }
}
exports.TwingFileExtensionEscapingStrategy = TwingFileExtensionEscapingStrategy;
